import SeparatorJF from "../../blueprints/separator-line/SeparatorJF";
import "../../components/houses/Houses.css";
import "./About.css";

function AboutHero() {
  return (
    <section className="about-hero">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="about-title">
            About <span>Us</span>
          </h2>

          <SeparatorJF width="420px" color="#0ea5e9" />

          <p className="about-subtitle">
            Since 1997, IQRAA Public School has been committed to providing
            quality education, nurturing young minds, and building future
            leaders through academic excellence, discipline, and values.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutHero;
